import { useClassrooms } from "@/hooks/useClassrooms";
import { useMyTrial } from "@/hooks/useMyTrial";
import { isTrialLocked } from "@/components/TrialBanner";
import LoadingSpinner from "@/components/LoadingSpinner";
import StudentWelcome from "./StudentWelcome";
import Line from "@/components/Line";
import { useAuth, getDisplayName } from "@/hooks/useAuth";
import ClassroomCard from "./ClassroomCard";

const StudentClassroomsView = () => {
  // Shared with the workspace shell, which names the open classroom in the
  // sidebar; revalidated here so the list is fresh whenever this page opens.
  const {
    classrooms: loadedClassrooms,
    error: loadError,
    reload,
  } = useClassrooms({ shouldRevalidate: true });
  const classrooms = loadedClassrooms ?? [];
  const { user } = useAuth();
  const { trial } = useMyTrial();
  const locked = trial ? isTrialLocked(trial) : false;

  // A failed refresh keeps the list already on screen.
  if (loadedClassrooms === null && loadError) {
    return (
      <div role="alert" className="et-group-error">
        <div className="text-center text-lg text-[#687368]">
          Failed to load classrooms. Please try again.
        </div>
        <button onClick={reload} className="et-primary">
          Try Again
        </button>
      </div>
    );
  }

  if (loadedClassrooms === null) {
    return <LoadingSpinner message="Loading classrooms..." />;
  }

  return (
    <div className="et-student-classrooms">
      <StudentWelcome name={getDisplayName(user)} />
      <div
        className={
          locked ? "pointer-events-none select-none opacity-60 blur-[2px]" : ""
        }
      >
        {classrooms.length === 0 ? (
          <div className="flex flex-col gap-4 text-center text-2xl font-bold p-8">
            <h3 className="text-lightgreen">Oopsssss......</h3>
            <h3 className="text-black">
              You aren't a part of any classrooms yet. Ask your teacher to
              assign you to a classroom!
            </h3>
          </div>
        ) : (
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <h1 className="text-2xl font-bold text-darkgreen">
                Your classrooms
              </h1>
              <Line />
            </div>
            <div className="et-classroom-grid">
              {classrooms.map((classroom) => (
                <ClassroomCard key={classroom.id} classroom={classroom} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentClassroomsView;
